export const BirdviewAttentionEntity = {
  Activity: 'activity',
  Request: 'request',
}
